import { render, staticRenderFns } from "./ExtensionsGraph.vue?vue&type=template&id=0fbc25f6"
import script from "./ExtensionsGraph.vue?vue&type=script&lang=ts"
export * from "./ExtensionsGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports